/**
 * Sales Orders sub-tab configuration for Admin Setup and the Purchasing page.
 */
import type { PurchasingTabsVisibility } from '../../../lib/api/types/common';

/** Tabs shown in Admin Setup → Purchasing → Tab Visibility. */
export const ACTIVE_PURCHASING_TAB_REGISTRY = [
  { id: 'po_headers', label: 'SO Headers', description: 'Sales Order header listing' },
  { id: 'po_lines', label: 'SO Lines', description: 'Sales Order line items with actions' },
  { id: 'asn', label: 'ASN', description: 'Advanced Shipping Notices' },
] as const;

const RETIRED_TAB_DEFAULTS: Partial<PurchasingTabsVisibility> = {
  pricing: false,
  forecast: false,
  deliveries: false,
  call_off: false,
  rfq: false,
};

/** Merge stored settings with retired tabs forced off. */
export function normalizePurchasingTabs(
  tabs: Partial<PurchasingTabsVisibility> | PurchasingTabsVisibility,
): PurchasingTabsVisibility {
  return {
    ...RETIRED_TAB_DEFAULTS,
    po_headers: tabs.po_headers ?? true,
    po_lines: tabs.po_lines ?? true,
    asn: tabs.asn ?? true,
  } as PurchasingTabsVisibility;
}

export const DEFAULT_PURCHASING_TABS = normalizePurchasingTabs({});

/** URL tab values that no longer exist on the Sales Orders page. */
export const RETIRED_PURCHASING_URL_TABS = new Set([
  'contract_pricing',
  'forecast',
  'delivery',
  'call_off',
]);
